import { TableColumnConfig } from '@shared/model';

export  const premierHealthColsConfig: TableColumnConfig[] = [
  { field: 'physicalStreet', header: 'Street', styles: { "width": "25%" } },
  { field: 'physicalCity', header: 'City', styles: { "width": "25%" } },
  { field: 'physicalState', header: 'State', styles: { "width": "25%" } },
  { field: 'physicalZip', header: 'ZIP Code', styles: { "width": "25%" } }
];
